import React from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import {
  getPermissonRolesAction,
  contactsPermissionsListingAction,
  deleteContactPermissionAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import AddContactPermission from "./CreateContactPermission";
import EditContactPermission from "./EditContactPermission";
import PhoneNumber from "../Common/phoneNumber";
import DataTable from "react-data-table-component";
import { toastMessage, humanize } from "../Common/Common";
import * as code from "../../config/Constants";
import { IconButton } from "@material-ui/core";
import {
  CheckCircle,
  CheckCircleOutline,
  Delete,
  Edit,
  Search,
} from "@material-ui/icons";
import ReactPaginate from "react-paginate";
import { DebounceInput } from "react-debounce-input";
import NoContact from "./../../assets/img/no-contact.jpg";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { cryptoTokenDecode } from "../Common/Common";
import * as message from "./../../config/CommonMessages";
import Logo from "./../../assets/img/logo.png";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants";
var CryptoJS = require("crypto-js");

const columns = [
  {
    name: "Name",
    selector: "firstname",
    sortable: true,
    ignoreRowClick: true,
    width: window.innerWidth <= 1366 ? "200px" : "",
  },
  {
    name: "Permission",
    selector: "role",
    sortable: true,
    width: window.innerWidth <= 1366 ? "200px" : "",
  },
  {
    name: "Mobile Number",
    selector: "mobileNumber",
    // sortable: true,
    width: window.innerWidth <= 1366 ? "200px" : "",
  },
  {
    name: "Email",
    selector: "email",
    sortable: true,
    width: window.innerWidth <= 1366 ? "200px" : "",
  },
  {
    name: "Status",
    selector: "isDeletedVendor",
    // sortable: true,
    width: "75px",
  },
  {
    name: "",
    selector: "edit",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
  {
    name: "",
    selector: "delete",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
];

function ContactsPermissions({
  getPermissonRolesAction,
  contactsPermissionsListingAction,
  deleteContactPermissionAction,
}) {
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const [contacts, setContacts] = React.useState([]);
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [contactData, setContactData] = React.useState({});
  const [showLoader, setShowLoader] = React.useState(false);
  const [numberOfPages, setnumberOfPages] = React.useState();
  const [PageNumber, setPageNumber] = React.useState(0);
  const [Rerander, setRerander] = React.useState(0);
  const [PageSize, SetPageSize] = React.useState(10);
  const [userRoles, setUserRoles] = React.useState([]);
  const [selectedRole, setSelectedRole] = React.useState("");
  const [usertype, setUsertype] = React.useState("");
  const [permissionarray, setPermissionarray] = React.useState([]);

  React.useEffect(() => {
    // console.log("hello-106");
    setShowLoader(true);
    getContactsWithPagination();
    var userType = cryptoTokenDecode().usertype;
    setUsertype(userType);
    let permission = localStorage.getItem("otherInfo");
    let permissionarray;
    if (permission) {
      let bytes = CryptoJS.AES.decrypt(permission, REACT_APP_CRYPTO_SECRET_KEY);
      let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      // console.log("decryptedData39", decryptedData);
      permissionarray = decryptedData.split(",");
      // console.log("permissionarray", permissionarray);
      setPermissionarray(permissionarray);
    }
  }, [PageNumber, Rerander]);

  const handlePageClick = (event) => {
    setPageNumber(event.selected);
  };

  const handleChange = (event) => {
    SetPageSize(event.target.value);
    setRerander(!Rerander);
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
    setRerander(!Rerander);
  };

  function getContactsWithPagination() {
    let formData = {
      page: PageNumber,
      searching: filterText,
      WantDeletedalso: true,
      SearchWithEmailAlso: true,
      PageSize: PageSize,
      roleFilter: selectedRole,
      ownerID: localStorage.getItem("ownerId"),
    };

    contactsPermissionsListingAction(formData)
      .then((res) => {
        if (res.status === code.OK) {
          setShowLoader(false);
          setContacts(res.data.data);
          setnumberOfPages(res.data.total);
          getPermissonRolesAction().then((roleList) => {
            setUserRoles(roleList);
          });
        } else {
          setShowLoader(false);
          setContacts([]);
        }
      })
      .catch((err) => {
        // console.log(err);
      });

    return contacts;
  }

  const Dosearch = (SearchValue) => {
    setFilterText(SearchValue);
    setRerander(!Rerander);
  };

  const handleClear = () => {
    setFilterText("");
    setSelectedRole("");
    setRerander(!Rerander);
  };

  function confirmDeletion(contact) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="">
            <div className="react-confirm-alert-body">
              <h2>Confirmation</h2>
              <p>Do you want to permanently delete this artist permission? </p>
              <div className="react-confirm-alert-button-group">
                <button
                  onClick={() => {
                    deleteContactPermission(contact._id);
                    onClose();
                  }}
                >
                  {" "}
                  Yes, Delete it!{" "}
                </button>
                <button onClick={onClose}>No</button>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  function deleteContactPermission(id) {
    setShowLoader(true);
    deleteContactPermissionAction(id)
      .then((res) => {
        setRerander(!Rerander);
      })
      .catch((err) => {
        // console.log(err);
      });
  }

  function showAddContactModal() {
    setShowAddModal(true);
  }

  function closeAddModal() {
    setShowAddModal(false);
    if (filterText) {
      setFilterText("");
      setRerander(!Rerander);
    } else {
      setRerander(!Rerander);
    }
  }

  function editContact(contact) {
    setShowEditModal(true);
    setContactData(contact);
  }

  function closeEditModal() {
    //getAllContacts();
    setShowEditModal(false);
    setRerander(!Rerander);
  }

  let rows = [];
  for (var i = 0; i < contacts.length; i++) {
    let contact = contacts[i];

    let contactObject = {
      id: contact._id,
      firstname:
        contact.UserData[0].firstname + " " + contact.UserData[0].lastname,
      role: contact.roles[0] ? humanize(contact.roles[0].name) : "",
      mobileNumber: (
        <PhoneNumber phoneNumber={contact.UserData[0].mobileNumber} />
      ),
      email: contact.UserData[0].email.address,
      isDeletedVendor:
        contact.isDeleted === false ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),
      delete:
        usertype == message.VENDOR &&
        permissionarray.includes(message.manage_permission_contact) &&
        contact.isDeleted === false ? (
          <IconButton
            onClick={() =>
              confirmDeletion(contact) && !contact.isDeleted === true
            }
          >
            <Delete />
          </IconButton>
        ) : usertype == message.ACCTOWNER && contact.isDeleted === false ? (
          <IconButton
            onClick={() =>
              confirmDeletion(contact) && !contact.isDeleted === true
            }
          >
            <Delete />
          </IconButton>
        ) : (
          ""
        ),

      edit:
        usertype == message.VENDOR &&
        permissionarray.includes(message.manage_permission_contact) &&
        contact.isDeleted === false ? (
          <IconButton
            onClick={() => editContact(contact) && !contact.isDeleted}
          >
            <Edit />
          </IconButton>
        ) : usertype == message.ACCTOWNER && contact.isDeleted === false ? (
          <IconButton
            onClick={() => editContact(contact) && !contact.isDeleted}
          >
            <Edit />
          </IconButton>
        ) : (
          ""
        ),
    };
    rows.push(contactObject);
  }

  return (
    <div>
      <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
        <Col xs="4">
          <h4 className="title-med mt-0 pt-1">Artists Permissions</h4>
        </Col>
        <Col align="right" className="contact-btn">
          {usertype == message.VENDOR &&
          permissionarray.includes(message.manage_permission_contact) ? (
            <Button
              variant="primary"
              className="btn-blue btn-head"
              onClick={() => {
                showAddContactModal();
              }}
            >
              Add Artist Permission
            </Button>
          ) : usertype == message.ACCTOWNER ? (
            <Button
              variant="primary"
              className="btn-blue btn-head"
              onClick={() => {
                showAddContactModal();
              }}
            >
              Add Artist Permission
            </Button>
          ) : (
            ""
          )}
        </Col>
      </Row>

      {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : rows.length === 0 ? (
        <>
          <Col className="col-auto" align="right">
            <Form inline className="justify-content-end">
              <Row className="trans-listing-head-row">
                <Col className="col-auto pl-0 d-flex trans-listing-head-dropdown">
                  <Form.Group controlId="" className="mb-0 mr-2">
                    <div className="c-select">
                      <select
                        className="form-control form-control-sm form-control-head"
                        style={{
                          minWidth: "130px",
                          width: "200px",
                          height: "38px",
                        }}
                        onChange={handleRoleChange}
                        value={selectedRole}
                      >
                        <option value="">Select Permission</option>
                        {userRoles &&
                          userRoles.map((role) => {
                            return (
                              <option key={role._id} value={role._id}>
                                {humanize(role.name)}
                              </option>
                            );
                          })}
                        {/* <option value="other">Other</option> */}
                      </select>
                    </div>
                  </Form.Group>
                  {/* </Col>
                <Col className="col-auto pl-0 d-flex"> */}
                  <Search style={{ marginTop: "7px" }} />
                  <DebounceInput
                    id="search"
                    minLength={0}
                    debounceTimeout={1500}
                    onChange={(e) => Dosearch(e.target.value)}
                    placeholder="Search"
                    value={filterText}
                    autoComplete="off"
                    className="form-control form-control-sm form-control-head"
                  />

                  <Button
                    type="button"
                    onClick={handleClear}
                    variant="primary"
                    className="btn-blue btn-head ml-2"
                    // style={{ marginRight: "19px" }}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>

          <div className="no-transaction no-contact">
            <div className="no-transaction-inner">
              <p className="color-grey-2">No artist permission found</p>
              <img src={Logo} className="no-transaction-content" alt="" />
              <h2 className="no-transaction-content">
                Manage your artists permissions
              </h2>
              <p className="no-transaction-content color-grey-1">
                Want to assign new artists permission,
                <br />
                click on "ADD ARTIST PERMISSION"
              </p>
              <Button
                className="text-uppercase btn-orange btn-orange-lg"
                onClick={() => {
                  // if (localStorage.getItem("isActive") === "false") {
                  //   toastMessage(
                  //     code.ERROR,
                  //     "Your subscription is not active. Please activate to continue."
                  //   );
                  // } else {
                  //   showAddContactModal();
                  // }
                  showAddContactModal();
                }}
              >
                Add Artist Permission
              </Button>
            </div>
          </div>
        </>
      ) : (
        <>
          <Col className="col-auto" align="right">
            <Form inline className="justify-content-end">
              <Row className="trans-listing-head-row">
                <Col className="col-auto pl-0 d-flex trans-listing-head-dropdown">
                  <Form.Group controlId="" className="mb-0 mr-2">
                    <div className="c-select">
                      <select
                        className="form-control form-control-sm form-control-head"
                        style={{
                          minWidth: "130px",
                          width: "200px",
                          height: "38px",
                        }}
                        onChange={handleRoleChange}
                        value={selectedRole}
                      >
                        <option value="">Select permission</option>
                        {userRoles &&
                          userRoles.map((role) => {
                            return (
                              <option key={role._id} value={role._id}>
                                {humanize(role.name)}
                              </option>
                            );
                          })}
                        {/* <option value="other">Other</option> */}
                      </select>
                    </div>
                  </Form.Group>

                  <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
                    <InputLabel id="demo-select-small">Limit</InputLabel>
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      value={PageSize}
                      label="Page"
                      onChange={handleChange}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
                <Col className="col-auto pl-0 d-flex">
                  <Search style={{ marginTop: "7px" }} />
                  <DebounceInput
                    id="search"
                    minLength={0}
                    debounceTimeout={1500}
                    onChange={(e) => Dosearch(e.target.value)}
                    placeholder="Search"
                    value={filterText}
                    autoComplete="off"
                    className="form-control form-control-sm form-control-head"
                  />

                  <Button
                    type="button"
                    onClick={handleClear}
                    variant="primary"
                    className="btn-blue btn-head ml-2"
                    style={{ marginRight: "19px" }}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
          <DataTable
            title="Contacts"
            columns={columns}
            data={rows}
            persistTableHead
          />
        </>
      )}

      {rows.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            pageCount={numberOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      )}
      <Modal
        show={showAddModal}
        onHide={() => closeAddModal()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="modal-med"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Add Artist Permission
          </Modal.Title>
        </Modal.Header>
        <AddContactPermission onClose={() => closeAddModal()} />
      </Modal>

      <Modal
        show={showEditModal}
        onHide={() => closeEditModal()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="modal-med"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Edit Artist Permission
          </Modal.Title>
        </Modal.Header>
        <EditContactPermission
          contactData={contactData}
          onClose={() => closeEditModal()}
        />
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
  };
};

export default connect(
  mapStateToProps,
  {
    getPermissonRolesAction,
    contactsPermissionsListingAction,
    deleteContactPermissionAction,
  }
)(ContactsPermissions);
